// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #2c3e50;
  overflow: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

* {
  box-sizing: border-box;
  -webkit-user-select: none;
          user-select: none;
}

#root {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Adiciona suporte a transformações 3D em todos os navegadores */
.isometric-board, .tile, .player, .dice, .dice-face {
  transform-style: preserve-3d;
  backface-visibility: hidden;
}

/* Nomes de classes semânticas */
.game-container {
  /* Container principal do jogo */
}

.isometric-board {
  /* Tabuleiro isométrico */
}

.tile {
  /* Bloco do tabuleiro */
}

.tile-fundo {
  /* Tiles de fundo */
}

.tile-caminho {
  /* Tiles de caminho */
}

.player {
  /* Avatar do jogador */
}

.player-idle {
  /* Jogador parado */
}

.player-walking {
  /* Jogador em movimento */
}

.dice {
  /* Container do dado */
}

.dice-face {
  /* Face do dado */
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EAGE,4BAA4B;EAG5B,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background: #2c3e50;\r\n  overflow: hidden;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  user-select: none;\r\n}\r\n\r\n#root {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* Adiciona suporte a transformações 3D em todos os navegadores */\r\n.isometric-board, .tile, .player, .dice, .dice-face {\r\n  -webkit-transform-style: preserve-3d;\r\n  -moz-transform-style: preserve-3d;\r\n  transform-style: preserve-3d;\r\n  -webkit-backface-visibility: hidden;\r\n  -moz-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n/* Nomes de classes semânticas */\r\n.game-container {\r\n  /* Container principal do jogo */\r\n}\r\n\r\n.isometric-board {\r\n  /* Tabuleiro isométrico */\r\n}\r\n\r\n.tile {\r\n  /* Bloco do tabuleiro */\r\n}\r\n\r\n.tile-fundo {\r\n  /* Tiles de fundo */\r\n}\r\n\r\n.tile-caminho {\r\n  /* Tiles de caminho */\r\n}\r\n\r\n.player {\r\n  /* Avatar do jogador */\r\n}\r\n\r\n.player-idle {\r\n  /* Jogador parado */\r\n}\r\n\r\n.player-walking {\r\n  /* Jogador em movimento */\r\n}\r\n\r\n.dice {\r\n  /* Container do dado */\r\n}\r\n\r\n.dice-face {\r\n  /* Face do dado */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
